import { useSelector } from 'react-redux'
import { useMemo } from 'react'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type CanceledNotificationValues = ReturnType<typeof useCanceledNotificationValues>

/**
 * That hook grabs canceledNotification values from the domain and returns them
 */
export function useCanceledNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return useMemo(() => {
    const { includeMessageUnsubscriptionInstructions, ...rest } =
      notificationSettings['canceledSettings']

    return {
      ...rest,
      windowOfCommitmentToleranceMins: '30',
      notificationCutoffMins: 0,
      proximityThresholdMins: '10',
      alwaysNotifyAfterCutoff: false,
      toleranceMins: 'No',
      windowOfCommitmentSnapToMins: 0,
      // includeMessageUnsubscriptionInstructions should alwayes be true for phone
      includeMessageUnsubscriptionInstructionsPhone: true,
      // includeMessageUnsubscriptionInstructions should be based on the value from the domain for email
      includeMessageUnsubscriptionInstructionsEmail: includeMessageUnsubscriptionInstructions,
    }
  }, [notificationSettings])
}
